export default {
  // 负一屏-非俄罗斯域名
  "en-dkmos.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1765791694130-0",
        slot: "/23161678951/en_dkmos_comfortweather_20251215_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1765791670045-0",
        // slot: "/23161678951/en_dkmos_comfortweather_20251215_bottom_anchor",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/en_dkmos_comfortweather_20251215_bottom_anchor",
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1765791717490-0",
        slot: "/23161678951/en_dkmos_comfortweather_20251215_300x250_1",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765791741550-0",
        slot: "/23161678951/en_dkmos_comfortweather_20251215_300x250_2",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765791853024-0",
        slot: "/23161678951/en_dkmos_comfortweather_20251215_300x250_3",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765791876767-0",
        slot: "/23161678951/en_dkmos_comfortweather_20251215_300x250_4",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 亮屏-非俄罗斯域名
  "en-dkso.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1765791350136-0",
        slot: "/23161678951/en_dkso_comfortweather_20251215_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1765791323718-0",
        // slot: "/23161678951/en_dkso_comfortweather_20251215_bottom_anchor",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/en_dkso_comfortweather_20251215_bottom_anchor",
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1765791371970-0",
        slot: "/23161678951/en_dkso_comfortweather_20251215_300x250_1",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765791393925-0",
        slot: "/23161678951/en_dkso_comfortweather_20251215_300x250_2",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765791419051-0",
        slot: "/23161678951/en_dkso_comfortweather_20251215_300x250_3",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765791441233-0",
        slot: "/23161678951/en_dkso_comfortweather_20251215_300x250_4",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 锁屏-非俄罗斯域名
  "en-dkls.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1765789501958-0",
        slot: "/23161678951/en_dkls_comfortweather_20251215_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1765789466572-0",
        // slot: "/23161678951/en_dkls_comfortweather_20251215_bottom_anchor",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/en_dkls_comfortweather_20251215_bottom_anchor",
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1765789573415-0",
        slot: "/23161678951/en_dkls_comfortweather_20251215_300x250_1",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765789600542-0",
        slot: "/23161678951/en_dkls_comfortweather_20251215_300x250_2",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765789627613-0",
        slot: "/23161678951/en_dkls_comfortweather_20251215_300x250_3",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765789526100-0",
        slot: "/23161678951/en_dkls_comfortweather_20251215_300x250_4",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 小部件-非俄罗斯域名
  "en-dkwg.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1765791527443-0",
        slot: "/23161678951/en_dkwg_comfortweather_20251215_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1765791501420-0",
        // slot: "/23161678951/en_dkwg_comfortweather_20251215_bottom_anchor",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/en_dkwg_comfortweather_20251215_bottom_anchor",
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1765791550045-0",
        slot: "/23161678951/en_dkwg_comfortweather_20251215_300x250_1",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765791574190-0",
        slot: "/23161678951/en_dkwg_comfortweather_20251215_300x250_2",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765791596208-0",
        slot: "/23161678951/en_dkwg_comfortweather_20251215_300x250_3",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765791618773-0",
        slot: "/23161678951/en_dkwg_comfortweather_20251215_300x250_4",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 智能窗-非俄罗斯域名
  "en-dksw.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1765791954375-0",
        slot: "/23161678951/en_dksw_comfortweather_20251215_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1765791930852-0",
        // slot: "/23161678951/en_dksw_comfortweather_20251215_bottom_anchor",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/en_dksw_comfortweather_20251215_bottom_anchor",
        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1765791979120-0",
        slot: "/23161678951/en_dksw_comfortweather_20251215_300x250_1",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765792002399-0",
        slot: "/23161678951/en_dksw_comfortweather_20251215_300x250_2",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765792024693-0",
        slot: "/23161678951/en_dksw_comfortweather_20251215_300x250_3",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765792049128-0",
        slot: "/23161678951/en_dksw_comfortweather_20251215_300x250_4",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // APP-非俄罗斯域名
  "en-dkapp.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1765789734626-0",
        slot: "/23161678951/en_dkapp_comfortweather_20251215_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      // 用在Home页面 改为用在主站每个页面的底部悬浮
      {
        type: "adx",
        id: "div-gpt-ad-1765789712697-0",
        slot: "/23161678951/en_dkapp_comfortweather_20251215_bottom_anchor",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-01",

        // type: "anchor",
        // slot: "/23161678951/en_dkapp_comfortweather_20251215_bottom_anchor",
        // position: "position-15",
      },
      //  用在Now页面
      {
        type: "adx",
        id: "div-gpt-ad-1765789686791-0",
        slot: "/23161678951/en_dkapp_comfortweather_20251215_bottom_anchor_home",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },

        // type: "anchor",
        // slot: "/23161678951/en_dkapp_comfortweather_20251215_bottom_anchor_home",
        position: "position-21",
      },
    ],
    // 用在pad上的广告
    ad3: [
      // app-pad融合首页banner
      {
        type: "adx",
        id: "div-gpt-ad-1767953450897-0",
        slot: "/23161678951/dkapp_comfortweather_tablet_20260109_728x90_home",
        rect: [728, 90],
        style: {
          // minWidth: "728px",
          minHeight: "90px",
        },
        position: "",
      },
      // app-pad主站底部锚定
      {
        type: "adx",
        id: "div-gpt-ad-1767953616889-0",
        slot: "/23161678951/dkapp_comfortweather_tablet_20260109_anchor",
        rect: [728, 90],
        style: {
          minWidth: "728px",
          minHeight: "90px",
        },

        // type: "anchor",
        // slot: "/23161678951/dkapp_comfortweather_tablet_20260109_anchor",
        position: "",
      },
      // app-pad主站页内banner
      {
        type: "adx",
        id: "div-gpt-ad-1767953672318-0",
        slot: "/23161678951/dkapp_comfortweather_tablet_20260109_728x90_1",
        rect: [728, 90],
        style: {
          // minWidth: "728px",
          minHeight: "90px",
        },
        position: "",
      },
      // app-pad主站页内banner
      {
        type: "adx",
        id: "div-gpt-ad-1767953754536-0",
        slot: "/23161678951/dkapp_comfortweather_tablet_20260109_728x90_2",
        rect: [728, 90],
        style: {
          // minWidth: "728px",
          minHeight: "90px",
        },
        position: "",
      },
      // app-pad主站页内banner
      {
        type: "adx",
        id: "div-gpt-ad-1767953810643-0",
        slot: "/23161678951/dkapp_comfortweather_tablet_20260109_728x90_3",
        rect: [728, 90],
        style: {
          // minWidth: "728px",
          minHeight: "90px",
        },
        position: "",
      },
      // app-pad主站页内banner
      {
        type: "adx",
        id: "div-gpt-ad-1767953833963-0",
        slot: "/23161678951/dkapp_comfortweather_tablet_20260109_728x90_4",
        rect: [728, 90],
        style: {
          // minWidth: "728px",
          minHeight: "90px",
        },
        position: "",
      },
      // app-pad融合首页右下角广告
      {
        type: "adx",
        id: "div-gpt-ad-1769348794291-0",
        slot: "/23161678951/dkapp_comfortweather_tablet_20260125_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1765789781938-0",
        slot: "/23161678951/en_dkapp_comfortweather_20251215_300x250_1",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765789804200-0",
        slot: "/23161678951/en_dkapp_comfortweather_20251215_300x250_2",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765789831431-0",
        slot: "/23161678951/en_dkapp_comfortweather_20251215_300x250_3",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1765789855278-0",
        slot: "/23161678951/en_dkapp_comfortweather_20251215_300x250_4",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "position-15",
      },
      //  用在Now页面
      {
        type: "adx",
        id: "div-gpt-ad-1765795857191-0",
        slot: "/23161678951/en_dkapp_comfortweather_20251215_300x250_home",
        rect: [300, 250],
        style: {
          minWidth: "300px",
          minHeight: "250px",
        },
        position: "",
      },
    ],
  },
  // 日历机-全球英语
  "en-dkcal.comfortweather.com": {
    // 用在pad上的广告
    ad3: [
      // app-pad融合首页banner
      {
        type: "adx",
        id: "div-gpt-ad-1772268170817-0",
        slot: "/23161678951/en_dkcal_comfortweather_20260228_728x90_home",
        rect: [728, 90],
        style: {
          // minWidth: "728px",
          minHeight: "90px",
        },
        position: "",
      },
    ],
  },

  // 日历机-俄罗斯域名暂不添加广告
};
